import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import map from 'lodash/map';
import every from 'lodash/every';

export const isDeepEmpty = (obj) => {
  if (isObject(obj)) {
    if (Object.keys(obj).length === 0) return true;
    return every(map(obj, (v) => isDeepEmpty(v)));
  } else if (isString(obj)) {
    return !obj.length;
  }
  return false;
};
